module.exports = __webpack_public_path__ + "img/FR11668.47f49be0.svg";